import { useEffect, useState } from 'react'
import { getToken } from './auth'

/** Also notices a login/logout in a second reader window. Never persist/log it. */
export function useAuthSession(): string | null {
  const [session, setSession] = useState(getToken)
  useEffect(() => {
    const update = () => setSession(getToken())
    const storage = (event: StorageEvent) => {
      if (event.key === 'nolos_jwt') update()
    }
    window.addEventListener('nolos-auth-changed', update)
    window.addEventListener('storage', storage)
    return () => {
      window.removeEventListener('nolos-auth-changed', update)
      window.removeEventListener('storage', storage)
    }
  }, [])
  return session
}
